import React, { useContext } from "react"
import { useTranslation } from "react-i18next"
import { NavLink } from "react-router-dom"

import { AppContext } from "../../context/AppContext"

import styles from "./NavFooter.module.scss"

const NavFooter = () => {
  const { t, i18n } = useTranslation()

  const appContext = useContext(AppContext)
  const { store } = appContext

  return (
    <nav className={styles.navFooter}>
      <NavLink
        to={`/${i18n.language}/${store.initConfig.url}terms-of-use`}
        target="_blank"
      >
        {t("Terms of Use")}
      </NavLink>{" "}
      <span>|</span>
      <NavLink
        to={`/${i18n.language}/${store.initConfig.url}privacy-policy`}
        target="_blank"
      >
        {t("Privacy Policy")}
      </NavLink>{" "}
      <span>|</span>
      <NavLink
        to={`/${i18n.language}/${store.initConfig.url}cookies-policy`}
        target="_blank"
      >
        {t("Cookies Policy")}
      </NavLink>
    </nav>
  )
}
export default NavFooter
